import { Link, useNavigate } from 'react-router-dom';
import { useCandidateAuth } from './CandidateAuthContext';

export function CareersNav() {
  const { account, loading, logout } = useCandidateAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/careers');
  };

  return (
    <div className="careers-topbar">
      <nav className="careers-topbar-inner">
        <Link to="/careers" className="careers-nav-brand">
          <img src="/verdantrise-logo.jpg" alt="Verdantrise Humanitarian Initiative" />
          Verdantrise Careers
        </Link>
        <span className="careers-nav-links">
          {loading ? null : account ? (
            <>
              <Link to="/careers/my-applications">My Applications</Link>
              <Link to="/careers/my-profile">My Profile</Link>
              <span className="muted">{account.fullName}</span>
              <button className="link-button" onClick={handleLogout}>Sign Out</button>
            </>
          ) : (
            <>
              <Link to="/careers/login">Sign In</Link>
              <Link to="/careers/signup">Create Account</Link>
            </>
          )}
        </span>
      </nav>
    </div>
  );
}
